import {KEY_GLOBAL_YOUTUBE_EMBED_MODE, KEY_INIT_WEB_BOOKMARK} from "@/Const";
import {generateUUID2} from "@/utils";

let mWebHistory:any = null;
export async function initWebHistory(db){
    mWebHistory = db.table('webHistory1');
    const szInit = localStorage.getItem(KEY_INIT_WEB_BOOKMARK);
    if (!szInit){

        let b1 = {
            id:'default_noteey_id',
            url:'https://www.noteey.com/',
            createTime:Date.now(),
            favicon:'https://d2hulr7xnfjroe.cloudfront.net/favicon_1e43dbb627.ico',
            title:'Noteey',
            isFavor:1,
            updateTime:Date.now(),
            favirateTime:Date.now()+1000
        }
        let item = await getWebHistoryByUrl(b1.url);
        if (!item){
            updateWebHistory(b1);
        }

        b1 = {
            id:'default_chatgpt_id',
            url:'https://chatgpt.com/',
            createTime:Date.now(),
            favicon:'https://cdn.oaistatic.com/assets/favicon-eex17e9e.ico',
            title:'ChatGPT',
            updateTime:Date.now(),
            isFavor:1,
            favirateTime:Date.now()
        }
        item = await getWebHistoryByUrl(b1.url);
        if (!item){
            updateWebHistory(b1);
        }
        localStorage.setItem(KEY_INIT_WEB_BOOKMARK,'true');
    }
}

export function updateWebHistory(webHistory){
    return mWebHistory.put(webHistory);
}

export async function getWebHistoryByUrl(szUrl){
    const arrayHistorys = await mWebHistory.where('url').equals(szUrl).toArray();
    if (arrayHistorys.length > 0){
        return arrayHistorys[0];
    }
    return null;
}

export async function getWebHistoryList(szSearchKey){
    let arrays;
    if (szSearchKey){
        arrays = await mWebHistory.filter(p=>p.url.includes(szSearchKey)).toArray();
        arrays.sort((a,b)=>{
            return a.createTime - b.createTime;
        })
    }else{
        arrays = await mWebHistory.toArray();
    }
    return arrays.slice(0,8);
}

export function getWebFavorList(){
    return mWebHistory.where('isFavor').equals(1).toArray();
}
